import { useQuery } from "@tanstack/react-query";
import { fetchSubCrewsPersonel } from "../api/fetchSubCrewsPersonel";

export const useSubCrewsPersonel = () => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["subCrewsPersonel"],
    queryFn: fetchSubCrewsPersonel,
  });

  return {
    data: data?.result || [],
    error,
    isLoading,
    refetch,
  };
};

